var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00732422H512V341.993H0V-0.00732422Z",
    fill: "#751A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00732422V341.993H150.3L188 322.393L150.3 303.493L188 284.493L150.3 265.593L188 246.593L150.3 227.593L188 208.693L150.3 189.693L188 170.693L150.3 151.793L188 132.793L150.3 113.893L188 94.8927L150.3 75.8927L188 56.9927L150.3 37.9927L188 19.0927L150.3 -0.00732422H0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/QA.5d126946e7685f47124eeeafbd11d62d.svg";
export { ForwardRef as ReactComponent };